import { useContext, useEffect, useState } from "react"
import { NotificacionesGeneral } from "../Context/Notificaciones_Context"

export function Alerta1()
{
    const {NotifiContext}=useContext(NotificacionesGeneral)
    const [activado,SetActivado]=useState<number>(1)
    useEffect(()=>{
        activador();
    },[NotifiContext])

    useEffect(()=>{
        activador();
    },[])

    const activador=()=>
    {
        if(NotifiContext[0].cantidad>0)
        {
            SetActivado(1);
        }else
        {
            SetActivado(0);
        }
    }

    return (
        <>
        {activado==1?<div className="alert alert-success alert-dismissible fade show" role="alert" style={{backgroundColor:"#e5f6eb"}}> <i className="bi-check-circle-fill" style={{backgroundColor:"00ad5f"}}></i> <span className="content small">{NotifiContext[0].cantidad==1?"Tiene 1 orden lista para su retiro":"Tiene "+NotifiContext[0].cantidad+" órdenes listas para su retiro"}  </span>
                <button type="button" className="btn-close" onClick={()=>SetActivado(0)}></button>
            </div>:null}
        </>
    )
}

